const updateAnalytic = (state, action) => {
  if (state === undefined) {
    return {
      chartLabels: [],
      chartSeries: [],
      tableCols: [],
      tableData: [],
      loading: false,
    };
  }

  switch (action.type) {
    case "ANALYTIC_LOADING":
      return {
        ...state.analytic,
        loading: action.payload,
      };
    case "ANALYTIC_DATA_FETCHED":
      return {
        ...state.analytic,
        ...action.payload,
      };

    default:
      return state.analytic;
  }
};

export default updateAnalytic;
